import React from "react";
import PropTypes from "prop-types";

import Navigation from "features/application/navigation";
import ReasonsToJoin from "features/application/reasons-to-join";
import Details from "features/application/details";
import About from "features/application/about";
import Interests from "features/application/interests";
import MembershipsView from "features/application/memberships/view";
import Payment from "features/application/payment";
import TermsAndConditions from "features/application/email-confirmation";
import CongratsView from "features/application/congrats/view";
import DownloadView from "features/application/download/view";

import "features/application/form/component/view.scss";

const FormView = ({
  responseCodes,
  errorCodes,
  currentStep,
  userData,
  reasons,
  interests,
  age,
  diversity,
  memberships,
  billingAddress,
  deleteCreditCard,
  termsAndConditions,
  resendVerificationMessage,
  validFields,
  invalidFields,
  removeValidField,
  setInvalidField,
  backToPreviousStep,
  sendApiRequest,
}) => (
  <section className={`application__form form__${currentStep}`}>
    <div
      className={`application__container form__container${
        currentStep === "memberships"
          ? " memberships__container"
          : currentStep === "reasons-to-join"
          ? " reasons-to-join__container"
          : currentStep === "interests"
          ? " interests__container"
          : ""
      }`}
    >
      {currentStep !== "congrats" &&
        currentStep !== "congratulations" &&
        currentStep !== "download" && (
          <Navigation
            currentStep={currentStep}
            memberships={memberships}
            userData={userData}
          />
        )}
      {currentStep === "reasons-to-join" ? (
        <ReasonsToJoin
          userData={userData}
          reasons={reasons}
          backToPreviousStep={backToPreviousStep}
        />
      ) : currentStep === "details" ? (
        <Details
          userData={userData}
          validFields={validFields}
          invalidFields={invalidFields}
          removeValidField={removeValidField}
          setInvalidField={setInvalidField}
          backToPreviousStep={backToPreviousStep}
          sendApiRequest={sendApiRequest}
        />
      ) : currentStep === "about" ? (
        <About
          userData={userData}
          backToPreviousStep={backToPreviousStep}
          sendApiRequest={sendApiRequest}
        />
      ) : currentStep === "interests" ? (
        <Interests
          interests={interests}
          age={age}
          diversity={diversity}
          backToPreviousStep={backToPreviousStep}
        />
      ) : currentStep === "memberships" ? (
        <MembershipsView
          userData={userData}
          memberships={memberships}
          sendApiRequest={sendApiRequest}
        />
      ) : currentStep === "payment" ? (
        <Payment
          errorCodes={errorCodes}
          billingAddress={billingAddress}
          deleteCreditCard={deleteCreditCard}
          validFields={validFields}
          removeValidField={removeValidField}
          setInvalidField={setInvalidField}
          backToPreviousStep={backToPreviousStep}
          sendApiRequest={sendApiRequest}
        />
      ) : currentStep === "email-confirmation" ? (
        <TermsAndConditions
          responseCodes={responseCodes}
          errorCodes={errorCodes}
          userData={userData}
          termsAndConditions={termsAndConditions}
          resendVerificationMessage={resendVerificationMessage}
          backToPreviousStep={backToPreviousStep}
          sendApiRequest={sendApiRequest}
        />
      ) : currentStep === "congrats" || currentStep === "congratulations" ? (
        <CongratsView />
      ) : (
        currentStep === "download" && <DownloadView />
      )}
    </div>
  </section>
);

FormView.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  currentStep: PropTypes.string,
  userData: PropTypes.object,
  reasons: PropTypes.array,
  interests: PropTypes.array,
  age: PropTypes.array,
  diversity: PropTypes.array,
  memberships: PropTypes.array,
  billingAddress: PropTypes.object,
  deleteCreditCard: PropTypes.func,
  termsAndConditions: PropTypes.object,
  resendVerificationMessage: PropTypes.func,
  validFields: PropTypes.array,
  invalidFields: PropTypes.array,
  removeValidField: PropTypes.func,
  setInvalidField: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
};

export default FormView;
